/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `Languages`
};

const fr_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `Langues`
};

const de_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `Sprachen`
};

const es_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `Idiomas`
};

const it_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `Lingue`
};

const ar_popular_disciplines_languages27 = /** @type {(inputs: {}) => string} */ () => {
	return `اللغات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const popular_disciplines_languages27 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.popular_disciplines_languages27(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("popular_disciplines_languages27", locale)
	if (locale === "en") return en_popular_disciplines_languages27(inputs)
	if (locale === "fr") return fr_popular_disciplines_languages27(inputs)
	if (locale === "de") return de_popular_disciplines_languages27(inputs)
	if (locale === "es") return es_popular_disciplines_languages27(inputs)
	if (locale === "it") return it_popular_disciplines_languages27(inputs)
	return ar_popular_disciplines_languages27(inputs)
};
export { popular_disciplines_languages27 as "POPULAR_DISCIPLINES_LANGUAGES" }